//export const baseURL = "https://beta-api.ezymigrate.co.nz/";
//export const baseURL = "https://uatapi.ezymigrate.co.nz/";
export const baseURL = 'https://linuxapi-stage.ezymigrate.co.nz/';

// Attach to window object for global access in non-module scripts
window.baseURL = baseURL;
